import { render, staticRenderFns } from "./UiFormErrors.vue?vue&type=template&id=5299ee59&"
import script from "./UiFormErrors.vue?vue&type=script&lang=js&"
export * from "./UiFormErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports